import { Box, Button, Grid, TextField, Typography } from '@material-ui/core';
import React, { FC } from 'react';

interface Props {
  formik: any;
  onClickGenerate: () => void;
  variant: 'quantity' | 'none' | 'generateCode';
}

export const SpecialField: FC<Props> = ({
  formik,
  onClickGenerate,
  variant = 'generateCode'
}) => {
  switch (variant) {
    case 'generateCode':
      return (
        <Grid item xs={12} md={6}>
          <Box display="flex" flexDirection="column" sx={{ width: '100%' }}>
            <Typography>Discount Voucher Code:</Typography>
            <TextField
              name="code"
              value={formik.values.code}
              onChange={(e) => {
                const newCode = e.target.value
                  .toUpperCase()
                  .replace(/[^A-Z0-9]/g, '');
                if (newCode.length <= 15) {
                  formik.setFieldValue('code', newCode);
                }
              }}
              fullWidth
              size="small"
              variant="outlined"
              inputProps={{
                maxLength: 15
              }}
              InputProps={{
                endAdornment: (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      columnGap: '1em',
                      marginRight: '-.94em'
                    }}
                  >
                    <Typography
                      variant="body2"
                      color={
                        (formik.values.code || '').length < 10
                          ? 'error'
                          : 'textSecondary'
                      }
                    >
                      {(formik.values.code || '').length}/15
                    </Typography>
                    <Button
                      variant="contained"
                      onClick={onClickGenerate}
                      color="primary"
                      style={{ height: '3em' }}
                    >
                      Generate
                    </Button>
                  </div>
                )
              }}
            />
          </Box>
          {formik.touched.code && formik.errors.code && (
            <Typography color="error" variant="caption" style={{ marginTop: 0.5 }}>
              {formik.errors.code}
            </Typography>
          )}
        </Grid>
      );
    case 'quantity':
      return (
        <Grid item xs={12} md={6}>
          <Box display="flex" flexDirection="column" sx={{ width: '100%' }}>
            <Typography>Quantity</Typography>
            <TextField
              name="quantity"
              value={formik.values.quantity}
              onChange={(e) => {
                const quantity = e.target.value;
                const numbersOnlyRegex = /^$|^[1-9][0-9]*$/;
                if (numbersOnlyRegex.test(quantity)) {
                  formik.setFieldValue('quantity', quantity ? +quantity : '');
                }
              }}
              inputProps={{
                min: 1, // Prevent negative values
                step: 1 // Ensure whole numbers only (no decimals)
              }}
              fullWidth
              size="small"
              onBlur={() => {
                if (!formik.values.quantity) {
                  formik.setFieldValue('quantity', 1); // reset to 1 if empty
                }
              }}
              variant="outlined"
            />
          </Box>
        </Grid>
      );
    case 'none':
    default:
      return null;
  }
};
